module.exports = __webpack_public_path__ + "img/128x128_star_unscannable_binary.f2a85298.svg";